import { render } from "./DashboardBtn.vue?vue&type=template&id=2a9a460f&scoped=true"
import script from "./DashboardBtn.vue?vue&type=script&lang=ts"
export * from "./DashboardBtn.vue?vue&type=script&lang=ts"

import "./DashboardBtn.vue?vue&type=style&index=0&id=2a9a460f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2a9a460f"

export default script